import * as React from "react";
import { IConfig } from "../../Config";
import { ViewType } from "../../NewsroomView";
import SimpleButton from "./SimpleButton";

interface IProps {
    isAdmin: boolean;
    config: IConfig;
    post: any;
    className?: string;
    type?: "a" | "button";
    text?: string;
    showIcon?: boolean;
    onSwitchView: (view: ViewType, newsId: string) => void;
}

const EditButton = (props: IProps) => {
    const url = props.post ? `/${props.config.portletInstanceId}/edit/${props.post.newsId}` : "#";
    const onEditPost = () => {
        props.onSwitchView(ViewType.EditForm, props.post.newsId);
    };

    return props.isAdmin ? (
        <SimpleButton
            className={props.className || "NR_itemLink CMS_button CMS_bSquare CMS_bWarn"}
            title="Edit"
            type={props.type}
            href={url}
            onClick={(e) => {
                e.preventDefault();
                onEditPost();
            }}
        >
            {props.showIcon ? <em className="fa fa-pencil"></em> : null} {props.text || ""}
        </SimpleButton>
    ) : null;
};

export default EditButton;
